// extracted by mini-css-extract-plugin
export default {"modalBody":"ModalWindow_modalBody__dAzOA","closeIcon":"ModalWindow_closeIcon__EuSyI","modalFullscreen":"ModalWindow_modalFullscreen__qJ9Ik"};